import { render, staticRenderFns } from "./CardPage.vue?vue&type=template&id=45cbe916&scoped=true&lang=html&"
import script from "./CardPage.vue?vue&type=script&lang=js&"
export * from "./CardPage.vue?vue&type=script&lang=js&"
import style0 from "./CardPage.vue?vue&type=style&index=0&id=45cbe916&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cbe916",
  null
  
)

export default component.exports